<template>
  <div>
    <div class="toolbtn flex">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>

    <!-- 检索 -->
    <div
      class="width100 f14 backwhite border-rd3 flex-betweenwrap"
      style="min-height: 72px"
      v-if="serchkey"
    >
      <el-form
        ref="ruleForm"
        size="small"
        label-width="80px"
        class="demo-ruleForm flexleft"
      >
        <el-form-item label="公司名称">
          <el-input placeholder="请输入公司名称" v-model="input"></el-input>
        </el-form-item>

        <div class="margin-left20 margin-top10 margin-bot10">
          <el-button type="primary" @click="submitForm()">检 索</el-button>
          <el-button @click="resetForm()">重 置</el-button>
        </div>
      </el-form>
      <div>
        <el-button class="margin-right10" @click.native="outerVisible = true"
          >没有找到？认证新企业</el-button
        >
        <span
          class="attention margin-top10 margin-bot10 margin-right20"
          @click="outerVisible = true"
          >新 增</span
        >
      </div>
    </div>
    <el-skeleton
      class="width100 backwhite border-rd3"
      :loading="true"
      animated
      :throttle="500"
      v-if="total != 0"
    >
      <template slot="template">
        <div class="width100 margin-auto margin-top20 pad-top20 alldigital">
          <el-table :data="page" class="eltable width98 margin-auto f14">
            <el-table-column label="企业名称" align="left">
              <template slot-scope="scope">
                <span class="bluecolor">{{ scope.row.company }}</span>
              </template></el-table-column
            >
            <el-table-column label="处理状态" align="center"
              ><template slot-scope="scope">{{
                scope.row.status
              }}</template></el-table-column
            >
            <el-table-column label="企业认证时间" align="center"
              ><template slot-scope="scope">{{
                scope.row.create_time.substring(0, 10)
              }}</template></el-table-column
            >
            <el-table-column
              label="操作"
              align="center"
              width="320"
              class-name="small-padding fixed-width"
            >
              <template slot-scope="scope">
                <span class="width15 bluecolor cursorpointer"
                  ><span @click="downloadreport(scope.row)"
                    >取消申请</span
                  ></span
                >
              </template>
            </el-table-column>
          </el-table>

          <div
            class="flex-betweennowrap pad-top20 pad-bot20 width98 margin-auto"
          >
            <span class="bluecolor f14 pad-left10"></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChange"
              @current-change="currentchange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="per_page"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
              v-if="total != 0"
            >
            </el-pagination>
          </div>
        </div>
      </template>
    </el-skeleton>
    <div
      class="width100 margin-auto backgroudFFF margin-top15"
      v-if="total == 0"
    >
      <el-empty
        :image="require('@/assets/barsvg/zwsj@3x.png')"
        :image-size="200"
        description="抱歉，没有搜到您想要的内容"
        class="heightempty"
        ><p style="position: relative; bottom: 60px" class="f14">
          暂无数据
        </p></el-empty
      >
    </div>
    <el-dialog
      title="企业认证"
      :visible.sync="outerVisible"
      center
      :close-on-click-modal="false"
      :show-close="true"
      width="30%"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        class="demo-ruleForm width98 margin-auto"
      >
        <el-form-item label="">
          <p>企业名称 <span class="Required">*</span></p>

          <el-input
            :maxlength="0"
            placeholder="请输入企业名称"
            v-model="ruleForm.pipo"
            @click.native="innerVisible = true"
          ></el-input>
        </el-form-item>
        <el-form-item label="" class="photo">
          <p>营业执照扫描件 <span class="Required">*</span></p>

          <el-upload
            class="avatar-uploader"
            :action="Apisrc"
            name="images"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :on-error="handleerror"
            :on-change="onchange"
            :data="user"
            :headers="head"
          >
            <img v-if="scanning" :src="scanning" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="Photodetails f12">
            <p>请上传企业营业执照扫描件</p>
            <p>格式为:jpg或png</p>
            <p>大小不超过2M</p>
          </div>
        </el-form-item>
        <el-form-item label="" class="photo">
          <p>法人身份证正面 <span class="Required">*</span></p>

          <el-upload
            class="avatar-uploader"
            :action="Apisrc"
            name="images"
            :show-file-list="false"
            :on-success="positivehandleAvatarSuccess"
            :on-error="positivehandleerror"
            :on-change="positiveonchange"
            :data="user"
            :headers="head"
          >
            <img v-if="positive" :src="positive" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="Photodetails f12">
            <p>请上传法人身份证正面（人像）</p>
            <p>格式为:jpg或png</p>
            <p>大小不超过2M</p>
          </div>
        </el-form-item>
        <el-form-item label="" class="photo">
          <p>法人身份证背面<span class="Required">*</span></p>

          <el-upload
            class="avatar-uploader"
            :action="Apisrc"
            name="images"
            :show-file-list="false"
            :on-success="backhandleAvatarSuccess"
            :on-error="backhandleerror"
            :on-change="backonchange"
            :data="user"
            :headers="head"
          >
            <img v-if="back" :src="back" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="Photodetails f12">
            <p>请上传法人身份证背面（国徽）</p>
            <p>格式为:jpg或png</p>
            <p>大小不超过2M</p>
          </div>
        </el-form-item>
        <el-form-item label="" prop="name">
          <p>用户联系人 <span class="Required">*</span></p>

          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <div class="textalign-right margin-top20">
          <el-button size="small" type="primary" @click="submitForms()"
            >提交</el-button
          >
        </div>
      </el-form>
      <el-dialog
        title="企业检索"
        center
        :close-on-click-modal="false"
        :show-close="true"
        width="25%"
        :visible.sync="innerVisible"
        append-to-body
      >
        <el-input v-model="search" class="width98 margin-bot10 margin-top20">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="searchEnterprise()"
          ></el-button>
        </el-input>
        <p
          class="
            width98
            margin-auto
            flex-between
            pad-top10 pad-bot10
            bodelbind
            f14
          "
          v-for="(item, index) in allenterprise"
          :key="index"
        >
          <span class="width85 pad-left10">{{ item.companyName }}</span
          ><span class="bluecolor width15" @click="Applybinding(index)"
            >申请绑定</span
          >
        </p>
      </el-dialog>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
  <script>
import {
  usermyapply,
  userremoveapply,
  companysearch,
  userapply,
} from "@/api/personal/personal.api";
import VueCookie from "vue-cookie";
import switchcore from "@/components/switchcore.vue";
import BUS from "@/BUS/BUS";
import callback from "@/components/callback.vue";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      thisNum: 1,
      currentPage1: 1,
      page: [],
      total: 0,
      per_page: 0,
      currentPage: 1,
      progres: { background: "red" },
      progress: "",
      outerVisible: false,
      innerVisible: false,
      ruleForm: {
        pipo: "",
        name: "",
        pipos: "",
      },
      user: {
        images: "",
      },
      head: {
        token: VueCookie.get("token"),
      },
      scanning: "",
      positive: "",
      back: "",
      search: "",
      allenterprise: [],
      serchkey: true,
      input: "",
      Apisrc: "",
    };
  },

  components: {
    callback,
    switchcore,
  },
  methods: {
    // 营业执照
    handleAvatarSuccess(response, res, file) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.scanning = window.g.Apisrc + response.data.url;
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
      }
    },
    handleerror(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      if (myError.code == 401) {
        this.dialogVisiblenull = false;
        this.$router.push({ path: "/login" });
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = myError.msg;
      }
    },
    onchange(file, fileList) {
      this.user.images =
        document.getElementsByClassName("el-upload__input")[0].value;
    },
    //法人身份证正面
    positivehandleAvatarSuccess(response, res, file) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.positive = window.g.Apisrc + response.data.url;
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
      }
    },
    positivehandleerror(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      if (myError.code == 401) {
        this.dialogVisiblenull = false;
        this.$router.push({ path: "/login" });
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = myError.msg;
      }
    },
    positiveonchange(file, fileList) {
      this.user.images =
        document.getElementsByClassName("el-upload__input")[0].value;
    },
    //法人身份证背面
    backhandleAvatarSuccess(response, res, file) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.back = window.g.Apisrc + response.data.url;
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
      }
    },
    backhandleerror(error, file, fileList) {
      let myError = error.toString(); //转字符串
      myError = myError.replace("Error: ", ""); // 去掉前面的" Error: "
      myError = JSON.parse(myError); //转对象
      this.$loadings.hide(); // 隐藏loading
      if (myError.code == 401) {
        this.dialogVisiblenull = false;
        this.$router.push({ path: "/login" });
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = myError.msg;
      }
    },
    backonchange(file, fileList) {
      this.user.images =
        document.getElementsByClassName("el-upload__input")[0].value;
    },
    // 企业认证申请
    submitForms() {
      this.$loading.hide(); // 隐藏loading
      if (this.scanning == "") {
        this.dialogVisiblenull = true;
        this.errormessage = "请上传营业执照扫描件";
        return;
      }
      if (this.positive == "") {
        this.dialogVisiblenull = true;
        this.errormessage = "请上传法人身份证正面(人像)";
        return;
      }
      if (this.back == "") {
        this.dialogVisiblenull = true;
        this.errormessage = "请上传法人身份证背面(国徽)";
        return;
      }

      userapply({
        realname: this.ruleForm.name,
        company: this.ruleForm.pipo,
        id_front: this.positive,
        id_backend: this.back,
        cert_file: this.scanning,
      }).then((res) => {
        if (res.data.code == 200) {
          this.outerVisible = false;
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 企业关键字检索
    submitForm() {
      if (this.input != "") {
        // // 获取企业
        usermyapply({ _keywords: this.input, page: 1 }).then((res) => {
          if (res.data.code == 200) {
            this.pagination = true;
            this.page = res.data.data.data;
            this.page.forEach((i) => {
              if (i.status == 0) {
                i.status = "未处理";
              } else if (i.status == 1) {
                i.status = "已认证";
              } else {
                i.status = "已拒绝";
              }
            });
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    // 申请绑定
    Applybinding(index) {
      this.innerVisible = false;
      this.ruleForm.pipo = this.allenterprise[index].companyName;
    },

    // 取消申请
    downloadreport(row) {
      this.$loading.hide(); // 隐藏loading
      this.$confirm("此操作将取消认证申请, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          userremoveapply({ id: row.id }).then((res) => {
            if (res.data.code == 200) {
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    // 第一个分页
    currentchange(val) {
      this.thisNum = val;
      usermyapply({
        _keywords: this.input,
        page: val,
      }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.page.forEach((i) => {
            if (i.status == 0) {
              i.status = "未处理";
            } else if (i.status == 1) {
              i.status = "已认证";
            } else {
              i.status = "已拒绝";
            }
          });
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      usermyapply({
        _keywords: this.input,
        page: 1,
        limit: val,
      }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.page.forEach((i) => {
            if (i.status == 0) {
              i.status = "未处理";
            } else if (i.status == 1) {
              i.status = "已认证";
            } else {
              i.status = "已拒绝";
            }
          });
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // input重 置
    resetForm() {
      this.input = null;
      this.thisNum = 1;
      usermyapply({
        // _keywords: window.sessionStorage.getItem("myapply"),
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.page = res.data.data.data;
          this.page.forEach((i) => {
            if (i.status == 0) {
              i.status = "未处理";
            } else if (i.status == 1) {
              i.status = "已认证";
            } else {
              i.status = "已拒绝";
            }
          });
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 企业关键字检索
    searchEnterprise() {
      companysearch({ company: this.search }).then((res) => {
        if (res.data.code == 200) {
          this.allenterprise = res.data.data;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      usermyapply({
        page: this.thisNum,
        _keywords: this.input,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pagination = true;
          this.page = res.data.data.data;
          this.page.forEach((i) => {
            if (i.status == 0) {
              i.status = "未处理";
            } else if (i.status == 1) {
              i.status = "已认证";
            } else {
              i.status = "已拒绝";
            }
          });
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    this.Apisrc = window.g.ApiUrl + "/oss_form";
    window.sessionStorage.setItem("default", "个人中心");

    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    this.$loading.show(); // 显示loading
    usermyapply({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.$loading.hide(); // 隐藏loading
        this.pagination = true;
        this.page = res.data.data.data;
        this.page.forEach((i) => {
          if (i.status == 0) {
            i.status = "未处理";
          } else if (i.status == 1) {
            i.status = "已认证";
          } else {
            i.status = "已拒绝";
          }
        });
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
      } else {
        this.$loading.hide(); // 隐藏loading
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
  <style scoped>
.editor >>> .el-date-editor--daterange.el-input__inner {
  width: 100%;
}

.avatar-uploader {
  width: 100px;
  height: 68px;
  border: 1px solid rgb(199, 198, 198);
  text-align: center;
  line-height: 68px;
}
.avatar {
  width: 100px;
  height: 68px;
}
.photo {
  position: relative;
}
.Photodetails {
  position: absolute;
  top: 30px;
  left: 120px;
  line-height: 25px;
  color: #767676;
}
.Required {
  color: red;
  position: absolute;
  left: -10px;
}
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 14px;
  color: #6a7589;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>